import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Solution } from './components/Solution';
import { HowItWorks } from './components/HowItWorks';
import { ProjectsCarousel } from './components/ProjectsCarousel';
import { Materials } from './components/Materials';
import { Bonuses } from './components/Bonuses';
import { MockupReminder } from './components/MockupReminder';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-cream font-sans text-ink" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problems data-id="element-4" />
        <Solution data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <MockupReminder data-id="element-7" />
        <ProjectsCarousel data-id="element-8" />
        <Materials data-id="element-9" />
        <Bonuses data-id="element-10" />
        <Offer data-id="element-11" />
        <Testimonials data-id="element-12" />
        <Faq data-id="element-13" />
        <FinalCta data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}